export enum Direction {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
  None = 'none',
}

export enum TileType {
  Wall = 0,
  Path = 1,
  Cheese = 2,
  PowerCheese = 3,
  CatDoor = 4,
  Empty = 5,
}

export enum CatState {
  Hunt = 'hunt',
  Patrol = 'patrol',
  Scared = 'scared',
  Fleeing = 'fleeing',
  InHouse = 'inhouse',
  Exiting = 'exiting',
}

export enum GamePhase {
  Ready = 'ready',
  Playing = 'playing',
  CatCaught = 'catcaught',
  Dying = 'dying',
  LevelComplete = 'levelcomplete',
  GameOver = 'gameover',
  Paused = 'paused',
}

export interface Position {
  x: number;
  y: number;
}

export interface TilePos {
  col: number;
  row: number;
}

export interface GameConfig {
  tileSize: number;
  mazeWidthTiles: number;
  mazeHeightTiles: number;
  playerSpeed: number;
  catSpeed: number;
  scaredCatSpeed: number;
  scaredDuration: number;
  huntDuration: number;
  patrolDuration: number;
}

export interface CatPersonality {
  name: string;
  color: string;
  scatterTarget: TilePos;
  getTargetTile: (
    playerTile: TilePos,
    playerDir: Direction,
    blinkyTile: TilePos,
    ownTile: TilePos,
  ) => TilePos;
}

export interface GameState {
  phase: GamePhase;
  score: number;
  lives: number;
  level: number;
  cheeseRemaining: number;
  totalCheese: number;
  comboMultiplier: number;
  extraLifeAwarded: boolean;
}
